import { render, staticRenderFns } from "./CompletePhdThesis.vue?vue&type=template&id=38cef3ea&scoped=true&"
import script from "./CompletePhdThesis.vue?vue&type=script&lang=js&"
export * from "./CompletePhdThesis.vue?vue&type=script&lang=js&"
import style0 from "./CompletePhdThesis.vue?vue&type=style&index=0&id=38cef3ea&prod&scoped=true&lang=css&"
import style1 from "./CompletePhdThesis.vue?vue&type=style&index=1&id=38cef3ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cef3ea",
  null
  
)

export default component.exports